// extracted by mini-css-extract-plugin
module.exports = {"sourceEditor":"styles_sourceEditor__3t548"};